import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/processes',
  	  method: 'get',
        params
  	})
  }
 
  export function inventory(params) {
    return request({
      url: '/processes/inventory',
      method: 'get',
      params
    })
  }

export function show(id) {
    return request({
      url: `/processes/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/processes',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/processes/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/processes/${id}`,
      method: 'delete',
    })
  }
